"use client";

import { Suspense, useEffect, useState } from "react";
import { useCookieConsent } from "../cookies";
import { GoogleTagManagerScripts } from "./GoogleTagManagerScripts";
import type { GtagConsent } from "./types";
import { updateGTMConsent } from "./utils";

function GoogleTagManagerWithoutConsent({
	gtmId,
	defaultConsent,
	onLoad,
}: {
	gtmId: string;
	defaultConsent: GtagConsent;
	onLoad?: () => void;
}) {
	return (
		<>
			<noscript>
				<iframe
					title="Google Tag Manager"
					src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
					height="0"
					width="0"
					style={{ display: "none", visibility: "hidden" }}
				/>
			</noscript>
			<Suspense>
				<GoogleTagManagerScripts
					gtmId={gtmId}
					defaultConsent={defaultConsent}
					onLoad={onLoad}
				/>
			</Suspense>
		</>
	);
}

function GoogleTagManagerWithConsent({
	gtmId,
	defaultConsent = "denied",
}: {
	gtmId: string;
	defaultConsent?: GtagConsent;
}) {
	const [isGtagLoaded, setIsGtagLoaded] = useState(false);
	const [hasSetConsent, setHasSetConsent] = useState(false);
	const { cookieConsent } = useCookieConsent();

	useEffect(() => {
		if (isGtagLoaded && !hasSetConsent) {
			if (cookieConsent?.analytics && cookieConsent?.marketing) {
				updateGTMConsent("granted");
			}
			// else {
			// 	updateGTMConsent("denied");
			// }

			setHasSetConsent(true);
		}
	}, [isGtagLoaded, hasSetConsent, cookieConsent]);

	return (
		<GoogleTagManagerWithoutConsent
			gtmId={gtmId}
			defaultConsent={defaultConsent}
			onLoad={() => setIsGtagLoaded(true)}
		/>
	);
}

export function GoogleTagManager({
	gtmId,
	defaultConsent = "denied",
}: {
	gtmId?: string;
	defaultConsent?: GtagConsent;
}) {
	if (gtmId === undefined) {
		return null;
	}

	if (defaultConsent === "granted") {
		return (
			<GoogleTagManagerWithoutConsent
				gtmId={gtmId}
				defaultConsent={defaultConsent}
			/>
		);
	}

	return (
		<GoogleTagManagerWithConsent
			gtmId={gtmId}
			defaultConsent={defaultConsent}
		/>
	);
}
